import React, { useEffect, useContext } from 'react';
import { SideNavigation, TopButton } from '../components';
import { SideNavContext } from '../contexts';
import Header from '../components/header/Header';
import MainVisual from '../components/mainVisual/MainVisual';
import Business from '../components/business/Business';
import CompanyStrength from '../components/companyStrength/CompanyStrength';
import MainPortfolio from '../components/mainPortfolio/MainPortfolio';
import Consultation from '../components/consultation/Consultation';
import Footer from '../components/footer/Footer';
import API_BASE_URL from '../config/api';

const Home = () => {

    const { isSideNavOpen } = useContext(SideNavContext);
    
    useEffect(() => {
        const recordVisit = async () => {
            
            try {
                await fetch(
                    `${API_BASE_URL}/api/visitors`,
                    {
                        method: 'POST',
                        credentials: 'include'
                    }
                );
            } catch (error) {
                console.error(
                    '방문 기록 오류:',
                    error
                );
            }
        };

        recordVisit();
    }, []);
    
    return (
        <>
            {isSideNavOpen && <SideNavigation />}
            <Header />
            <main>
                <MainVisual />
                <Business />
                <CompanyStrength />
                <MainPortfolio />
                <Consultation />
            </main>
            <Footer />
            <TopButton />
        </>
    );
};


export default Home;